function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(255, 255, 255)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {'arancio': 'rgb(255, 165, 0)','azzurro': 'rgb(0, 191, 255)','bianco': 'rgb(255, 255, 255)','bianco-arancio': 'rgb(255, 255, 255)','black-camo': 'rgb(0, 0, 0)','blu': 'rgb(0, 0, 255)','blu-chiaro': 'rgb(173, 216, 230)','blu-scuro': 'rgb(0, 0, 139)','blu-arancio': 'rgb(0, 0, 255)','blu-rosa': 'rgb(0, 0, 255)','cedar-n-black': 'rgb(75, 54, 33)','fireorange-n-brack': 'rgb(255, 69, 0)','giallo': 'rgb(255, 255, 0)','grigio': 'rgb(128, 128, 128)','grigio-blu': 'rgb(128, 128, 128)','grigio-verde': 'rgb(128, 128, 128)','marrone': 'rgb(139, 69, 19)','marrone-chiaro': 'rgb(210, 180, 140)','nero': 'rgb(0, 0, 0)','nero-arancio': 'rgb(0, 0, 0)','nero-bianco': 'rgb(0, 0, 0)','nero-bianco-oro': 'rgb(0, 0, 0)','nero-blu': 'rgb(0, 0, 0)','nero-giallo': 'rgb(0, 0, 0)','nero-grigio': 'rgb(0, 0, 0)','nero-rosso': 'rgb(0, 0, 0)','nero-rosso-beige': 'rgb(0, 0, 0)','nero-rosso-blu': 'rgb(0, 0, 0)','nero-verde': 'rgb(0, 0, 0)','oro': 'rgb(255, 215, 0)','rosa': 'rgb(255, 192, 203)','rosso': 'rgb(255, 0, 0)','verde': 'rgb(0, 128, 0)','verde-arancio': 'rgb(0, 128, 0)','verde-nero': 'rgb(0, 128, 0)','viola': 'rgb(128, 0, 128)',};

    this.images = {};

    this.triggers = ['colori','colore',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

const Swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  Swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);

export default Swatches;
